import { SET_CURRENT_FOOD_COURT } from "../actions";

export default function setFoodCourt(payload) {
    return {
      type: SET_CURRENT_FOOD_COURT,
      payload
    }
  }


// WEBPACK FOOTER //
// ./src/store/actionCreators/currentFoodCourt.js